import {apiPost} from './api';
import moment from 'moment';
import * as XLSX from 'xlsx';
import imageCompression from 'browser-image-compression';

async function compressImage(file) {
    const imageFile = file;

    const options = {
        maxSizeMB: 4,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
    };

    try {
        return await imageCompression(imageFile, options);
    } catch (error) {
        console.log(error.message);
    }
}

export function uploadFile(
    file,
    uploadStartCallback,
    fileUploadCompleteCallback,
    fileUploadFailedCallback
) {
    (uploadStartCallback || (() => {
    }))();
    if (['image/jpg', 'image/jpeg', 'image/png'].includes(file.type)) {
        compressImage(file).then((file) => {
            return uploadToServer(
                file,
                uploadStartCallback,
                fileUploadCompleteCallback,
                fileUploadFailedCallback
            );
        });
    } else {
        uploadToServer(
            file,
            uploadStartCallback,
            fileUploadCompleteCallback,
            fileUploadFailedCallback
        );
    }
}

async function uploadToS3(signedUrl, file) {
    await fetch(signedUrl, {
        method: 'PUT',
        headers: {'Content-Type': file.type},
        body: file
    })
    return signedUrl.split('?')[0]
}

const fileResponse = (s3Url) => {
    return {
        fileUrl: s3Url,
        time: moment().unix()
    }
}

export const uploadToServer = (
    file,
    uploadStartCallback,
    fileUploadCompleteCallback,
    fileUploadFailedCallback
) => {
    if (file) {
        const reader = new FileReader();
        reader.onload = function (readerEvt) {
            const binaryString = readerEvt.target.result;
            (uploadStartCallback || (() => {
            }))();
            apiPost(
                '/upload_url',
                {
                    body: {
                        filename: `${moment().unix()}_${file.name}`
                    }
                }
            ).then((response) => {
                if (response.error) {
                    throw response.error
                }
                uploadToS3(response.data['uploadUrl'], file).then((response) => {
                    const fileData = fileResponse(response)
                    if (response.error) {
                        throw response.error;
                    }
                    (fileUploadCompleteCallback || (() => {
                    }))(fileData, file);
                })
                    .catch(fileUploadFailedCallback || (() => {
                    }))
            })
                .catch(fileUploadFailedCallback || (() => {
                }));
        };

        reader.readAsBinaryString(file);
    }
};

export const workSheetReader = (file, onRead) => {
    if (file) {
        const reader = new FileReader();

        reader.onload = function (readerEvt) {
            const binaryString = readerEvt.target.result;
            const wb = XLSX.read(binaryString, {type: 'binary'});
            onRead(
                (wb.SheetNames || []).reduce(
                    (workBook, sheetName) => ({
                        ...workBook,
                        [sheetName]: XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
                            defval: '',
                        }),
                    }),
                    {}
                ),
                wb.SheetNames
            );
        };

        reader.readAsBinaryString(file);
    }
};

export const getSheetHeaders = (sheet) => {
    return [
        ...new Set([
            ...((sheet || []).reduce(
                (header, currentEntry) => [
                    ...header,
                    ...Object.keys(currentEntry || {}),
                ],
                []
            ) || []),
        ]),
    ];
};
